import {Injectable, OnDestroy} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter, retry} from 'rxjs/operators';
import {catchError, interval, Subscription, switchMap, throwError, timer} from "rxjs";
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService implements OnDestroy {
  private routeSubscription: Subscription | null = null;
  private refreshSubscription: Subscription | null = null;
  private readonly MONITORING_URL = '/grade/create';
  private readonly TIME_OF_REFRESH = 5 * 60 * 1000;

  constructor(private router: Router, private authService: AuthService) {
  }

  startMonitoring(): void {
    // Подписываемся на события смены маршрутов
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if ((event as NavigationEnd).url === this.MONITORING_URL) {
          this.startRefreshTimer();
        } else {
          this.stopRefreshTimer();
        }
      });
  }

  private startRefreshTimer(): void {
    if (!this.refreshSubscription) {
      this.refreshSubscription = interval(this.TIME_OF_REFRESH)
        .pipe(
          switchMap(() => this.authService.refreshToken()
            .pipe(
              retry({
                count: 3, // Максимальное количество повторений
                delay: (error, retryCount) => {
                  console.log(`Попытка ${retryCount} провалена. Повтор через 30 секунд...`);
                  return timer(30000);
                },
              }),
              catchError((err) => {
                console.error('Все попытки обновления токена исчерпаны:', err);
                this.authService.logout();
                return throwError(() => new Error('Failed to refresh token after retries'));
              })
            ))
        )
        .subscribe({
          next: ({token, refreshToken}: { token: string; refreshToken: string }) => {
            this.authService.token = token;
            this.authService.refreshTokenKey = refreshToken;
            console.log('Token refreshed successfully');
          },
          error: (err) => {
            console.error('Failed to refresh token after retries', err);
          },
        });
    }

    console.log('Token refresh timer started');
  }


  private stopRefreshTimer(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
      console.log('Token refresh timer stopped');
    }
  }

  ngOnDestroy(): void {
    this.stopRefreshTimer();
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
      this.routeSubscription = null;
    }
  }
}
